import { BoxIcon } from 'assets/icons';
import styles from './no-collaborators-found.module.scss';

const NoCollaboratorsFound: React.FC = () => (
  <div className={styles.emptyPage}>
    <BoxIcon className={styles.boxIcon} />
    <div className={styles.emptyPageTexts}>
      <p className="text__title2__gray700">No results found</p>

      <span className="text__body__regular__medium__gray800">
        Try adjusting your filters.
      </span>
    </div>
  </div>
);

export { NoCollaboratorsFound };
